import { schema } from 'normalizr'
import $axios from '@/axiosInstance.js'

export default {
	namespaced: true,
	state: {
		forecast: {
			'jobid':'',
			'order':{},
			'order_placed':false
			// 'year':'',
			// 'month':'',
			// 'firstdate':'',
			// 'first_order':{},
			// 'first_order_placed':false,
			// 'seconddate':'',
			// 'second_order_placed':false,
			// 'second_order':{}
		}
	},
	mutations: {
		addForecastOrder (state, payload) {
			state.forecast.jobid = payload.jobId
			// if(payload.year)
			// {
			// 	state.forecast.year = payload.year
			// }
			// if(payload.month)
			// {
			// 	state.forecast.month = payload.month
			// }
			
			console.log(payload)
			// if(payload.type =='first')
			// {
				// if(payload.fcdate!=''){
				// 	state.forecast.date = payload.fcdate
				// }
				if(payload.order!=''){
					state.forecast.order = payload.order
					state.forecast.order_placed = true
				}
			// }
			// else if(payload.type =='second') 
			// {
			// 	if(payload.fcdate!=''){
			// 		state.forecast.seconddate = payload.fcdate
			// 	}
            //     if(payload.order!=''){
			// 		state.forecast.second_order = payload.order
			// 		state.forecast.second_order_placed = true
			// 	}
			// }
			
		},
		removeForecastOrder (state, payload) {
            // if(payload.type =='firstdate')
			// {
                // state.forecast.date = ''
				state.forecast.order = {}
				state.forecast.order_placed = false
			// }
			// else if(payload.type =='seconddate') 
			// {
            //     state.forecast.seconddate = ''
            //     state.forecast.second_order = {}
			// 	state.forecast.second_order_placed = false
            // }
		},
		emptyStore(state) {
			state.forecast.jobid = ''
			// state.forecast.date = ''
			state.forecast.order = {}
			state.forecast.order_placed = false
		}
	},
	actions: {
		loadOrder ({ commit }, credentials) {
			//TODO: fetch here rather than in component? Maybe Maybe not!! below is fake, not implimented
			return $axios.post('XXXX', credentials)
				.then((response) => {
					// commit('setArea', response.data.area_products)
					// commit('setPhase', response.data.phase_products)
					// etc etc
				})
		}
	},
	getters: {
		getForecast ({ forecast }) {
			return forecast
		}
	}
}